export default "__VITE_ASSET__BwXbCpHt__"